import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import { JobCard } from "../../components/JobCard";
import { CandidateTabs } from "../../components/candidate/CandidateTabs";

export default function Saved() {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/candidate/saved").then(({ data }) => setJobs(data || [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const onToggleSaved = (id, saved) => {
    if (!saved) setJobs((prev) => prev.filter((j) => j.id !== id));
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
      <h1 className="font-heading text-3xl font-bold text-stone-text mb-6">{t("candidate.saved.title")}</h1>
      <CandidateTabs />

      {loading ? (
        <div className="py-16 text-center text-stone-muted">{t("jobs.loading")}</div>
      ) : jobs.length === 0 ? (
        <div className="py-16 text-center text-stone-muted" data-testid="saved-empty">{t("candidate.saved.empty")}</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-testid="saved-list">
          {jobs.map((job) => (
            <JobCard key={job.id} job={job} saved onToggleSaved={onToggleSaved} />
          ))}
        </div>
      )}
    </div>
  );
}
